import '../styles/main.scss'
import React from 'react'
import { createRoot } from 'react-dom/client'
import Fancybox from "./utils/fancybox";
import Accordion from './components/accordion'
import BasicModal from './components/basicModal'
import Slider from './components/slider'
import Base from './components/base'

import AOS from 'aos'
import 'aos/dist/aos.css'

document.addEventListener('DOMContentLoaded', () => {
    Fancybox();
    AOS.init();

    document.querySelectorAll('.form-input, .form-textarea').forEach(input => {

        const parent = input.closest('.input-group');

        if (input.value) parent.classList.add('has-value');

        input.addEventListener('focus', () => parent.classList.add('focused'));
        input.addEventListener('blur', () => {
            input.value ? parent.classList.add('has-value') : parent.classList.remove('focused', 'has-value');
        });
        input.addEventListener('input', () => {
            input.value ? parent.classList.add('has-value') : parent.classList.remove('has-value');
        });

    });

    /* mobile */

    const burgerMenu = document.getElementById('burger-menu');
    const mobileMenu = document.getElementById('mobile-menu');

    burgerMenu.addEventListener('click', () => {
        mobileMenu.classList.toggle('hidden');
        mobileMenu.classList.toggle('open-nav');
        burgerMenu.classList.toggle('open-nav');
    });

});